module.exports = __webpack_public_path__ + "img/Catalogue_empty.8a3b4190.png";